import Link from "next/link";
import {scrollToElement} from "@/utils/scrollToElement";

export const VMWARE_CONSTANTS = {
  title: "VMware Cloud Pricing",
  data: [
    {
      numberOfHosts: 2,
      ram: "2 * 48 GB",
      cpu: "12c/24t - 2.2 GHz",
      storage: "2 * 3 TB",
      pricePerMonth: "$2,237.13 ",
    },
    {
      numberOfHosts: 2,
      ram: "2 * 96 GB",
      cpu: "12c/24t - 2.2 GHz",
      storage: "2 * 3 TB",
      pricePerMonth: "$2,551.71 ",
    },
    {
      numberOfHosts: 2,
      ram: "2 * 192 GB",
      cpu: "16c/32t - 2.8 GHz",
      storage: "2 * 3 TB",
      pricePerMonth: "$2,740.71 ",
    },
    {
      numberOfHosts: 2,
      ram: "2 * 384 GB",
      cpu: "32c/64t - 2.8 GHz",
      storage: "2 * 3 TB",
      pricePerMonth: "$4,122.09 ",
    },
    {
      numberOfHosts: 2,
      ram: "2 * 768 GB",
      cpu: "32c/64t - 2.8 GHz",
      storage: "2 * 3 TB",
      pricePerMonth: "$5,104.05 ",
    },
  ],
};

export const FOOTER_CONSTANTS = {
  btnText: "Ready To Buy?",
  text1: (
    <>
      Our VMware Cloud packs are designed to scale with your business. Pricing shown is an
      estimate and can vary based on configuration, contract term, and additional
      services. Please contact{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        target="_blank"
        style={{textDecoration: "underline", color: "#1E87F0", fontWeight: 700}}
      >
        sales
      </Link>{" "}
      for a personalized quote and more details.
    </>
  ),
};
